import { useEffect, useState } from 'react'
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import fondo from '../img/chombaverde.webp'
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';

///////////////////////////////////////////
import { useDispatch } from 'react-redux'
import {
    loginUsuario,
} from '../Redux/usuarios.js'
import { Link, Navigate, useNavigate } from 'react-router-dom'
//////////////////////////////////////////
import * as yup from 'yup'
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup'
import CustomTextField from '../Components/CustomTextField';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { toast } from 'react-toastify';
import { UserAuth } from '../context/AuthContext';

const LoginAdmin = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { signInAdmin, loading, signInWithMicrosoft, user } = UserAuth()

    const defaultValues = {
        email: '',
        password: ''
    };

    const validationSchema = yup.object().shape({
        password: yup.string().required("Por favor escribe tu Contraseña"),
        email: yup
            .string()
            .email() //el.email es para que valide que realmente este escribiendo un email
            .required("Por favor escribe tu Correo Electrónico")
    });

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(validationSchema),
        mode: "onChange"
    });

    const {
        handleSubmit,
        // reset, 
        // trigger 
    } = methods;


    //loader en boton
    const buttonSx = {
        ...(loading && {
            bgcolor: green[500],
            '&:hover': {
                bgcolor: green[700],
            },
        }),
    };

    const ProcesarLogin = async (datos) => {
        // setIsFormSubmitted(true);
        const { email, password } = datos

        try {
            await signInAdmin(email, password)
                .then(() => {
                    navigate("/inicio")
                })
        } catch (error) {
            toast.error('Email o Contraseña invalidos', {
                theme: "dark",
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            console.log(error.message)
        }
        // console.log(datos)
        // if (!loading) {
        //     dispatch(loginUsuario(email, password))
        // }
    }

    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    }

    if (user?.email?.length > 0) {
        return <Navigate to="/inicio" />;

    }
    return (
        <Grid container component="main" sx={{ height: '100vh' }}>
            <CssBaseline />
            <Grid
                item
                xs={false}
                sm={4}
                md={7}
                sx={{
                    backgroundImage: `url(${fondo})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <Box
                    sx={{
                        my: 8,
                        mx: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography variant="h5">
                        Bienvenido
                    </Typography>
                    <FormProvider {...methods}>
                        <form>
                            <Box sx={{ mt: 1 }}>
                                <CustomTextField
                                    Component={TextField}
                                    type="text"
                                    name="email"
                                    label="Correo Electrónico"
                                    // helperText="Por favor escribe tu Correo Electrónico"
                                    rules={{ required: "Required!" }}
                                // onChange={e => setMail(e.target.value)}
                                />
                                <CustomTextField
                                    Component={TextField}
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    label="Contraseña"
                                    // helperText="Por favor escribe tu Contraseña"
                                    rules={{ required: "Required!" }}
                                    endAdornment={
                                        <IconButton onClick={handleTogglePassword} edge="end">
                                          {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    }
                                />
                                <Box sx={{ mt: 3, mb: 2, position: 'relative' }}>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        sx={buttonSx}
                                        disabled={loading}

                                        onClick={handleSubmit(ProcesarLogin)}
                                    >
                                        Ingresar
                                    </Button>
                                    {loading && (
                                        <CircularProgress
                                            size={24}
                                            sx={{
                                                color: green[500],
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                        />
                                    )}
                                </Box>
                            </Box>
                        </form>
                    </FormProvider>
                </Box>
            </Grid>
        </Grid>
    )
}

export default LoginAdmin